<template>
    <div class="after-sale-reqpair-pc">
        <a-tabs type="card" v-model:activeKey="activeKey">
            <a-tab-pane key="incomingMaterial" tab="来料问题">
                <incoming-material v-if="activeKey === 'incomingMaterial'"></incoming-material>
            </a-tab-pane>
            <a-tab-pane key="incomingMaterialStatistics" tab="来料问题统计">
                <incoming-material-statistics
                    v-if="activeKey === 'incomingMaterialStatistics'"></incoming-material-statistics>
            </a-tab-pane>
            <a-tab-pane key="qualityInspection" tab="质检问题">
                <quality-inspection v-if="activeKey === 'qualityInspection'"></quality-inspection>
            </a-tab-pane>
            <a-tab-pane key="qualityInspectionStatistics" tab="质检问题统计">
                <quality-inspection-statistics
                    v-if="activeKey === 'qualityInspectionStatistics'"></quality-inspection-statistics>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import incomingMaterial from '@/views/productDaily/problem/incomingMaterial.vue';
import incomingMaterialStatistics from '@/views/productDaily/problem/incomingMaterialStatistics.vue';
import qualityInspection from "@/views/productDaily/problem/qualityInspection.vue";
import qualityInspectionStatistics from "@/views/productDaily/problem/qualityInspectionStatistics.vue";
import { useRoute } from "vue-router";

export default defineComponent({
    components: {
        incomingMaterial,
        incomingMaterialStatistics,
        qualityInspection,
        qualityInspectionStatistics
    },
    setup(props, context) {
        const route = useRoute();

        const activeKey = ref('incomingMaterial');

        // const produceOrTpc = route.meta.produceOrTpc;

        if (route.query.activeKey) activeKey.value = route.query.activeKey;

        return {
            activeKey
        };
    },
});
</script>

<style lang="less" scoped>
.after-sale-reqpair-pc {
    background: #fff;
    box-shadow: 3px 3px 8px 4px rgba(8, 26, 81, 0.04);
    padding: 20px;
    border-radius: 10px;
    height: calc(100vh - 120px);
}
</style>
